const licenseAgreementConfig = {
  headers: [
    'END USER LICENSE AGREEMENT (EULA) FOR SAAS USE OF PROCESSHUB',
    'IMPORTANT – READ CAREFULLY:'
  ],
  description: [
    'This End User License Agreement (“Agreement”) is a legal agreement between you (either an individual or a single entity, referred to herein as “you” or “Licensee”) and **Takamul Technologies** (“Licensor”) for the use of the ProcessHub SaaS platform.',
    '**BY CLICKING “ACCEPT,” OR BY INSTALLING, ACCESSING OR USING PROCESSHUB, YOU AGREE TO BE BOUND BY THIS AGREEMENT.** IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, DO NOT INSTALL, ACCESS, OR USE PROCESSHUB.'
  ],
  content: [
    {
      header: '1. DEFINITIONS',
      content: `
**“ProcessHub”** refers to the digital twin software solution owned by Takamul Technologies.  
**“Services”** means the hosted access and use of ProcessHub via a SaaS delivery model.  
**“User Data”** means all data submitted by Licensee or its users to ProcessHub.  
**“Intellectual Property Rights”** means all patents, copyrights, trademarks, trade secrets, and other intellectual property rights recognized worldwide.  
      `
    },
    {
      header: '2. GRANT OF LICENSE',
      content: `
Subject to your compliance with this Agreement, Takamul Technologies grants you a **non-exclusive, non-transferable, non-sublicensable** right to access and use ProcessHub for your internal business purposes only.
      `
    },
    {
      header: '3. LICENSE RESTRICTIONS',
      content: `
You may not:
- Reverse engineer, decompile, or disassemble ProcessHub.
- Use ProcessHub for any unlawful, harmful, or abusive activity.
- Modify, rent, lease, loan, sell, distribute, or create derivative works based on ProcessHub.
- Share your access credentials or make ProcessHub available to third parties.
      `
    },
    {
      header: '4. INTELLECTUAL PROPERTY',
      content: `
ProcessHub and all related components are the exclusive property of Takamul Technologies. This Agreement does not grant you any ownership rights to ProcessHub.
      `
    },
    {
      header: '5. DATA RIGHTS AND PRIVACY',
      content: `
- You retain ownership of your User Data.
- Takamul Technologies may process and store your data in accordance with applicable data protection laws (including GDPR, CCPA, and relevant Middle East regulations).
- Security measures will be implemented to protect your data against unauthorized access.
      `
    },
    {
      header: '6. CONFIDENTIALITY',
      content: `
You agree to keep confidential all non-public information disclosed by Takamul Technologies, including system architecture, documentation, and pricing information.
      `
    },
    {
      header: '7. COMPLIANCE WITH LAWS',
      content: `
You agree to comply with all applicable international, federal, state, and local laws and regulations, including export laws, privacy laws, and cybersecurity regulations.
      `
    },
    {
      header: '8. WARRANTY DISCLAIMER',
      content: `
ProcessHub is provided **“AS IS”** without warranties of any kind. Takamul Technologies does not guarantee uninterrupted or error-free operation of ProcessHub.
      `
    },
    {
      header: '9. LIMITATION OF LIABILITY',
      content: `
To the maximum extent permitted by law, Takamul Technologies shall not be liable for indirect, incidental, special, or consequential damages. The total liability shall not exceed the amount paid for the service in the past six (6) months.
      `
    },
    {
      header: '10. TERMINATION',
      content: `
This Agreement is effective until terminated. Your rights will automatically terminate without notice from Takamul Technologies if you fail to comply with any term(s). Upon termination, you must cease all use of ProcessHub and destroy all related materials.
      `
    },
    {
      header: '11. EXPORT AND SANCTIONS COMPLIANCE',
      content: `
You may not use or access ProcessHub in violation of applicable export or sanctions laws.
      `
    },
    {
      header: '12. GOVERNING LAW',
      content: `
This Agreement shall be governed by the laws of Saudi Arabia, without regard to its conflict of law principles. Disputes shall be resolved in accordance with the rules of courts of Dubai.
      `
    },
    {
      header: '13. MISCELLANEOUS',
      content: `
- **Entire Agreement:** This is the entire agreement between you and Takamul Technologies regarding ProcessHub.
- **Modifications:** Changes must be in writing and accepted by both parties.
- **Force Majeure:** Neither party is liable for events beyond reasonable control.
- **Severability:** If a provision is invalid, the rest of the agreement remains enforceable.
- **Assignment:** You may not transfer your rights under this Agreement without prior written approval.
      `
    }
  ],
  conclusion: 'BY CLICKING “ACCEPT” OR USING PROCESSHUB, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THIS AGREEMENT AND AGREE TO BE BOUND BY ITS TERMS.',
  action: 'Accept'
};

export default licenseAgreementConfig;